export default function Features(){
   
   
    return (
        <div className="container--big-row ">
            <div className="content-section">
            <h3 className="content-section--2title special-color">FEATURES</h3>
            <h1 className="content-section--1title">Why Choose <span className="special-color-1">Meow </span><span className="special-color">Hosting</span></h1>
            <p className="content-section--para">Your success is our mission. Meow Hosting-Where Performance Meets <em>Purrfection</em>.</p>
            <div className="services_list">
                <div className="services_item">
                <div className="services_icon">
                <i class="fa-solid fa-bolt"></i>
                </div>
                <div className="services_item--description">
                <h2 className="services_item--title">Blazing-Fast Speed</h2>
                <p className="services_item--para">We understand the importance of speed for your online success. Our cutting-edge infrastructure and optimized servers guarantee lightning-fast loading times for your websites and applications.</p>
                </div>
                </div>
                <div className="services_item">
                <div className="services_icon">
                <div className="services_icon-space">
                <i class="fa-solid fa-headset"></i>
                </div>
                </div>
                <div className="services_item--description">
                <h2 className="services_item--title">24/7 Expert Support</h2>
                <p className="services_item--para">Have questions or need assistance? Our dedicated support team is available round-the-clock to provide expert guidance and solve any issues you may encounter.</p>
                </div>
                </div>
                <div className="services_item">
                <div className="services_icon">
                <i class="fa-solid fa-shield"></i>
                </div>
                <div className="services_item--description">
                <h2 className="services_item--title">Top-Notch Security</h2>
                <p className="services_item--para">Your data's security is our priority. With advanced security measures, including firewalls, malware scanning, and regular backups, your digital assets are in safe hands.</p>
                </div>
                </div>
                <div className="services_item">
                <div className="services_icon">
                <i class="fa-solid fa-stopwatch"></i>
                </div>
                <div className="services_item--description">
                <h2 className="services_item--title">Unrivaled Uptime</h2>
                <p className="services_item--para">Say goodbye to downtime! Our robust network architecture and proactive monitoring ensure that your websites stay up and running, providing an exceptional browsing experience to your visitors</p>
                </div>
                </div>
                <div className="services_item">
                <div className="services_icon">
                <i class="fa-solid fa-user-gear"></i>
                </div>
                <div className="services_item--description">
                <h2 className="services_item--title">Easy User Control Panel</h2>
                <p className="services_item--para">Manage your hosting effortlessly with our intuitive control panel. From setting up email accounts to installing applications, you're in complete control.</p>
                </div>
                </div>
                <div className="services_item">
                <div className="services_icon">
                <i class="fa-solid fa-maximize"></i>
                </div>
                <div className="services_item--description">
                <h2 className="services_item--title">Scalability</h2>
                <p className="services_item--para">As your online presence grows, we'll grow with you. Easily upgrade your hosting plans to accommodate increasing traffic and demands without any hassle.</p>
                </div>
                </div>
            </div>

            </div>
        </div>
        
        )
}